"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.typedMemo = exports.applyTableConfDefaults = exports.getValue = void 0;
var get_1 = __importDefault(require("lodash/get"));
var react_1 = require("react");
var getValue = function (item, field, extractors) {
    var _a;
    return (extractors && field in extractors ? (_a = extractors === null || extractors === void 0 ? void 0 : extractors[field]) === null || _a === void 0 ? void 0 : _a.call(extractors, item) : (0, get_1.default)(item, field));
};
exports.getValue = getValue;
var applyTableConfDefaults = function (tableConf) {
    var _a, _b;
    return (__assign(__assign({}, tableConf), { layout: __assign(__assign({}, tableConf.layout), { fixedColumns: (_b = (_a = tableConf.layout) === null || _a === void 0 ? void 0 : _a.fixedColumns) !== null && _b !== void 0 ? _b : 1 }) }));
};
exports.applyTableConfDefaults = applyTableConfDefaults;
exports.typedMemo = react_1.memo;
